import styled, { css } from "styled-components";
import CustomInputNumber from "common/Inputs/CustomInputNumber";
import {
  getNewLookTokens,
  NEW_LOOK_RADIUS,
  newLookType,
} from "common/NewLook/tokens.ts";

const SelectorInput = styled(CustomInputNumber)`
  &::placeholder {
    color: ${(p) => p.theme.colors.secondaryText};
  }
  color: ${(p) => p.theme.colors.secondaryText};
  ${(p) =>
    p.theme.isNewLook &&
    css`
      && {
        color: ${getNewLookTokens(p.theme).ink};
        background: transparent;
        box-shadow: none;
        ${newLookType.figure};
      }
      && input {
        background: transparent;
        text-align: right;
      }
      &&::placeholder,
      && input::placeholder {
        color: ${getNewLookTokens(p.theme).muted};
      }
    `}
`;

const SelectorWrapper = styled.div`
  border: 1px solid #f0f0f0;
  border-radius: 8px;
  padding: 16px;
  margin-top: 10px;
  ${(p) =>
    p.theme.isNewLook &&
    css`
      /* An inset well under its label, not a hand-drawn box. */
      margin-top: 6px;
      padding: 12px 16px 14px;
      border: 1px solid ${getNewLookTokens(p.theme).hairline};
      border-radius: ${NEW_LOOK_RADIUS.control}px;
      background: ${getNewLookTokens(p.theme).well};
    `}
`;

/** New look: a field label above a control (label role). */
const SelectorLabel = styled.div`
  ${newLookType.label};
  color: ${(p) => getNewLookTokens(p.theme).secondary};
`;

/** New look: the value row's name ("Number of Users"). */
const SelectorValueName = styled.div`
  ${newLookType.body};
  font-weight: 500;
  color: ${(p) => getNewLookTokens(p.theme).ink};
`;

/** New look: helper text under a control (meta role). */
const SelectorHelp = styled.div`
  margin-top: 6px;
  ${newLookType.meta};
  color: ${(p) => getNewLookTokens(p.theme).muted};
`;

export {
  SelectorInput,
  SelectorWrapper,
  SelectorLabel,
  SelectorValueName,
  SelectorHelp,
};
